<template>
    <div class="container">
        <div class="text-wrapper">
            <p class="contact">Services</p>
            <p class="title">Building solutions, <br /> one innovation at a time.</p>
        </div>

        <div class="tabs-wrapper">
            <div class="tab" v-for="tab in tabs">
                <div class="icon-wrapper">
                    <img :src="tab.icon" alt="">
                </div>
                <p class="sub-title">{{ tab.title }}</p>
                <p class="description">{{ tab.description }}</p>
                <ul class="items">
                    <li v-for="item in tab.items">{{ item }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import services1 from '@/assets/icons/services1.svg';
import htmlIcon from '@/assets/icons/html.svg';
export default {
    name: 'ServicesOffered',
    data() {
        return {
            tabs: [
                {
                    title: 'What I can do for you?',
                    description: 'Faster, better products that your users love. Here\'s all the services I provide:',
                    items: [
                        'Web development',
                        'Mobile App development',
                        'System design'
                    ],
                    icon: services1
                },
                {
                    title: 'Frontend frameworks I\'m fluent in',
                    description: 'I build responsive and interactive interfaces using a variety of modern frontend frameworks.',
                    items: [
                        'React',
                        'Vue',
                        'Angular',
                        'Sveltekit'
                    ],
                    icon: htmlIcon
                },
                {
                    title: 'What you can expect?',
                    description: 'I design products that are more than pretty.I make them shippable and usable.',
                    items: [
                        'Clean and functional',
                        'User friendly',
                        'Efficient and maintainable'
                    ],
                    icon: services1
                },
            ],
            activeTab: 'Vue'
        };
    },
    computed: {
        activeCode() {
            return this.tabs.find(tab => tab.name === this.activeTab).code;
        },
        activeOutput() {
            return this.tabs.find(tab => tab.name === this.activeTab).output;
        }
    },
    methods: {
        setActiveTab(tabName) {
            this.activeTab = tabName;
        }
    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 80px 120px;
    display: flex;
    gap: 60px;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    font-family: 'Poppins';
}

.text-wrapper {
    display: flex;
    gap: 12px;
    flex-direction: column;
    text-align: center;
}

.contact {
    font-size: 1.5rem;
    font-weight: 600;
    background: linear-gradient(134.15deg, #B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.title {
    font-size: 2rem;
    font-weight: 600;
    color: #fff;
}

.description {
    font-size: 18px;
    color: #fff;
}

.tabs-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 32px;
}

.tab {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
}


.icon-wrapper {
    border-radius: 32px;
    padding: 20px;
    border: 1px solid #252626;
    background-color: #0C0C0D;
    display: flex;
    align-items: center;
    width: fit-content;
}

.icon-wrapper img {
    width: 32px;
    height: 32px;
}

.items {
    padding-left: 1.5rem;
}

.sub-title {
    font-size: 1.5rem;
    line-height: 1.7rem;
    font-weight: 600;
}

.description {
    font-size: 1.1rem;
    color: var(--secondary-text-color);
    line-height: 1.8rem;
    font-weight: 400;
}

ul {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-size: 1rem;
    font-weight: 400;
    color: var(--primary-text-color);
}


@media (max-width: 700px) {
    .container {
        padding: 32px;
        gap: 32px;
    }

    .tabs-wrapper {
        flex-direction: column;
    }

    .title, .sub-title {
        font-size: 1.2rem;
    }

    .description {
        font-size: 1rem;
        line-height: 1.5rem;
    }

    .contact {
        font-size: 1rem;
        font-weight: 600;
    }

    .icon-wrapper {
        align-self: center;
    }
}
</style>